import React from 'react';
import PropTypes from 'prop-types';
import {
  FDBox,
} from '@facet-wealth/design';
import JobsSectionPicker from './JobsSectionPicker';

const Jobs = ({ relationship }) => {
  return (
    <FDBox padding={2}>
      <JobsSectionPicker relationship={relationship} />
    </FDBox>
  );
};


Jobs.propTypes = {
  relationship: PropTypes.object.isRequired,
};

export default Jobs;
